<template>
    <div>
        <component :is="currentComponent" @goToComponent="handleComponentChange" :goods_id="componentParams.goods_id"
            :partner_id="componentParams.partner_id">
        </component>
    </div>
</template>
<script>
import ProductList from './goods/ProductList.vue'
import AddProduct from './goods/AddProduct.vue'



export default {
    name: 'ShopOrders',
    components: {
        ProductList,
        AddProduct
    },
    data() {
        return {
            currentComponent: 'ProductList', // 默认显示订单列表
            componentParams: {
                goods_id: '',
                partner_id: ''
            }
        }
    },
    mounted() {
        // 组件挂载时默认显示订单列表
        this.currentComponent = 'ProductList';
    },
    methods: {
        // 处理组件切换
        handleComponentChange(componentName, params) {
            if (params) {
                // 如果是发布商品（没有goods_id），则重置goods_id
                if (componentName === 'AddProduct' && !params.goods_id) {
                    this.componentParams = { 
                        ...this.componentParams, 
                        ...params,
                        goods_id: '' // 重置goods_id
                    };
                } else {
                    this.componentParams = { ...this.componentParams, ...params };
                }
            }
            this.currentComponent = componentName;
        }
    }
}
</script>

<style scoped>
/* 可以根据需要添加样式 */
</style>